import React, { useCallback } from "react";
import PurchaseDocDetails from "../../_components/Purchasing/PurchaseDocDetails";
import {
    getPurchaseInvoiceById,
    updatePurchaseInvoice,
    createPurchaseInvoice,
    deletePurchaseInvoice,
} from "../../_services/purchase.service";
import { getActiveSupplierCompanyNames } from "../../_services/contact.service";
import { companyProfileService } from "../../_services/companyProfile.service";
import { fetchContactPersons, fetchSupplierDetails, usePurchaseInvoiceReferenceFields } from "./purchaseInvoiceShared";

const fetchIndirectPI = (id) => getPurchaseInvoiceById(id).then(res => {
    if (res.piType !== "Indirect") throw new Error("Not an Indirect PI");
    return res;
});

const wrapCreate = (data) => createPurchaseInvoice({ ...data, piType: "Indirect" });
const wrapUpdate = (id, data) => updatePurchaseInvoice(id, { ...data, piType: "Indirect" });

export default function IndirectPurchaseInvoiceDetails() {
    const fetchCompProfile = useCallback(() => companyProfileService.getProfile(), []);
    const { extraFields } = usePurchaseInvoiceReferenceFields({ piType: "Indirect" });

    return (
        <PurchaseDocDetails
            docType="Indirect Purchase Invoice"
            basePath="/finance/indirect-purchase-invoices"
            fetchById={fetchIndirectPI}
            updateItem={wrapUpdate}
            deleteItem={deletePurchaseInvoice}
            createItem={wrapCreate}
            fetchSupplierNames={getActiveSupplierCompanyNames}
            fetchContactPersons={fetchContactPersons}
            fetchSupplierDetails={fetchSupplierDetails}
            fetchCompanyProfile={fetchCompProfile}
            taxRate={0}
            searchable={false}
            searchSource="RM"
            extraFields={extraFields}
        />
    );
}
